module.exports = __webpack_public_path__ + "static/media/search.db5d8122.svg";